import isEmpty from 'lodash/isEmpty';
import toString from 'lodash/toString';
import type { ContactRequestForm, HotpadsListing, PropertyInfo } from './types';
import { getAnalyticsErrorType } from '@zg-rentals/rentals-analytics';
import { logError } from '@zg-rentals/log-error';

const nullPropertyInfoValues = {
  property_info: {
    listing_alias: null,
    lot_id: null,
    listing_status_cd: null,
    is_paid_ind: null,
    property_type_cd: null,
    listing_type_cd: null,
  },
};

export function getPropertyInfo(listing?: HotpadsListing | null): PropertyInfo {
  try {
    // null, undefined, or empty objects result in `true`
    if (isEmpty(listing)) {
      return nullPropertyInfoValues;
    }

    if (listing.units) {
      listing = listing.units[0];
    }

    const {
      active,
      aliasEncoded,
      isPaidMultifamily,
      listingType = '',
      maloneLotIdEncoded: maloneLotId,
      propertyType = '',
    } = listing;

    const listingActive = toString(active);

    return {
      property_info: {
        listing_alias: aliasEncoded,
        lot_id: maloneLotId,
        listing_status_cd: listingActive,
        is_paid_ind: isPaidMultifamily,
        property_type_cd: propertyType,
        listing_type_cd: listingType,
      },
    };
  } catch (error) {
    logError({ error, errorType: getAnalyticsErrorType('getPropertyInfo'), context: { argumentPassed: listing } });

    return nullPropertyInfoValues;
  }
}

export function getContactRequestForm(rentalSubmitId: string): ContactRequestForm {
  return {
    contact_request_form: {
      rental_submit_id: rentalSubmitId,
    },
  };
}

export function getEnvelope(data: {
  eventId: string;
  eventVersion: string;
  templateId?: string;
  templateVersion?: string;
}) {
  return {
    event_type_id: data.eventId,
    event_type_version_id: data.eventVersion,
    event_template_id: data.templateId || '',
    event_template_version_id: data.templateVersion || '',
  };
}
